// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import {
  IAccidentDetailTransportation,
  IFile,
} from '@accidents/shared/interfaces/accident-transportation';

// ----------- General Actions -----------
// ---------------------------------------
export const reset = createAction('[Detail Accident Transportation] - Reset');

export const getAccidentDetailRequested = createAction(
  '[Detail Accident Transportation] - Detail Accident Requested',
  props<{ payload: string }>()
);

export const getAccidentDetailSuccess = createAction(
  '[Detail Accident Transportation] - Detail Accident Success',
  props<{ payload: IAccidentDetailTransportation }>()
);

export const clearAccidentDetail = createAction(
  '[Detail Accident Transportation] - Clear Accident Detail'
);

export const getAccidentDetailFailure = createAction(
  '[Detail Accident Transportation] - Detail Accident Failure'
);

export const addAccidentFilesRequested = createAction(
  '[Detail Accident Transportation] - Add Accident Files Requested',
  props<{ payload: { id: string; files: IFile[] } }>()
);

export const addAccidentFilesResponse = createAction(
  '[Detail Accident Transportation] - Add Accident Files Response',
  props<{ payload: IFile[] }>()
);

export const addAccidentFilesFailure = createAction(
  '[Detail Accident Transportation] - Add Accident Files Failure'
);

export const updateAccidentFileRequested = createAction(
  '[Detail Accident Transportation] - Update Accident File Requested',
  props<{ payload: { id: string; file: IFile } }>()
);

export const updateAccidentFileResponse = createAction(
  '[Detail Accident Transportation] - Update Accident File Response'
);

export const deleteAccidentFileRequested = createAction(
  '[Detail Accident Transportation] - Delete Accident File Requested',
  props<{ payload: { id: string; file: IFile } }>()
);

export const deleteAccidentFileResponse = createAction(
  '[Detail Accident Transportation] - Delete Accident File Response'
);

export const reprocessAccidentRequested = createAction(
  '[Detail Accident Transportation] - Reprocess Accident Requested',
  props<{ payload: string }>()
);

export const reprocessAccidentResponse = createAction(
  '[Detail Accident Transportation] - Reprocess Accident Response'
);

export const downloadAccidentFilesZipRequest = createAction(
  '[Detail Accident Transportation] - Download Accident Files Zip Requested',
  props<{ payload: { id: string; accessToken: string } }>()
);

export const downloadAccidentFilesZipResponse = createAction(
  '[Detail Accident Transportation] - Download Accident Files Zip Response'
);
